import { Router } from '@angular/router';
import { throwError } from 'rxjs';


export abstract class BaseService {

  constructor() { }

  protected handleError(error: { headers: { get: (key: string) => string | null }, json: () => Record<string, string[]> }) {

    const applicationError = error.headers.get('Application-Error');

    if (applicationError) {
      return throwError(applicationError);
    }

    let modelStateErrors: string = '';
    const serverError = error.json();

    if (!serverError.type) {
    for (const key in serverError) {
      if (serverError[key]) {
      modelStateErrors += serverError[key] + '\n';
      }
    }
  }

    modelStateErrors = modelStateErrors === '' ? null : modelStateErrors;
    return throwError(modelStateErrors || 'Server error');


  }

}
